import { useEffect, useRef } from 'react';

/**
 * Remembers the value a component saw on its previous render. Writes the current value into a ref after each render, so reads during a render still see the prior one.
 *
 * @param value - Value to remember for the next render.
 * @returns The value from the previous render, or undefined on the first.
 */
function usePrevious<T>(value: T) {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export default usePrevious;
